<template>
  <div class="materials-warning-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="tableLoading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                prop="name"
                fixed="left"
                label="物料名称"
                show-overflow-tooltip
                width="180"
              >
              </el-table-column>
              <el-table-column
                prop="img"
                align="center"
                label="图片"
                width="100"
              >
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.img"
                    style="width: 80px; height: 80px"
                    :src="scope.row.img"
                    fit="contain"
                    :preview-src-list="[scope.row.img]"
                  >
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="brand_name"
                label="品牌"
                show-overflow-tooltip
                align="center"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="spec"
                align="center"
                show-overflow-tooltip
                width="120"
                label="规格"
              >
              </el-table-column>
              <el-table-column
                prop="unit"
                align="center"
                show-overflow-tooltip
                width="90"
                label="单位"
              >
              </el-table-column>
              <el-table-column
                prop="cost"
                align="center"
                show-overflow-tooltip
                width="90"
                label="成本价"
              >
              </el-table-column>
              <el-table-column
                prop="price"
                align="center"
                show-overflow-tooltip
                width="90"
                label="售单价"
              >
              </el-table-column>
              <!--              <el-table-column-->
              <!--                show-overflow-tooltip-->
              <!--                label="门店标配"-->
              <!--                align="center"-->
              <!--                width="100">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.is_standard===1">标配 {{scope.row.standard}}</el-tag>-->
              <!--                  <el-tag :disable-transitions="true" type="info" size="mini" v-if="scope.row.is_standard!==1">非标配</el-tag>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column
                prop="remark"
                label="备注"
                show-overflow-tooltip
                min-width="150"
              >
              </el-table-column>
              <!--                  <el-table-column-->
              <!--                    prop="addTime"-->
              <!--                    label="添加时间"-->
              <!--                    align="center"-->
              <!--                    show-overflow-tooltip-->
              <!--                    width="150">-->
              <!--                  </el-table-column>-->
              <el-table-column
                prop="wraning"
                align="center"
                show-overflow-tooltip
                fixed="right"
                width="90"
                label="预警线"
              >
              </el-table-column>
              <el-table-column
                prop="stock"
                align="center"
                show-overflow-tooltip
                fixed="right"
                width="90"
                label="库存"
              >
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#f56c6c">{{ scope.row.stock }}</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                align="center"
                show-overflow-tooltip
                label="操作"
                width="120"
              >
                <template slot-scope="scope">
                  <el-button size="mini" icon="el-icon-edit-outline" @click="operateStock(1, scope.row)">入库</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :title="stockTitle===0?'出库':'入库'"
      :visible.sync="stockDialog"
      width="40%"
      :before-close="handleClose"
    >
      <el-form ref="stockForm" v-loading="stockFormLoading" size="small" :model="stockForm" label-width="60px" :rules="rules">
        <el-form-item label="物料" prop="index">
          <el-select v-model="stockForm.mid" style="width: 100%;" disabled>
            <el-option :label="stockForm.material_name + ' ' + stockForm.material_spce" :value="stockForm.mid">
              <span style="float: left">{{ stockForm.material_name }} {{ stockForm.material_spce }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ stockForm.brand_name || stockForm.brandName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="num">
          <el-input-number v-model="stockForm.num" :min="1" :max="999999"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="stockForm.remark"
            type="textarea"
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="btnLoading" type="primary" @click="subStock('stockForm')">立即提交</el-button>
          <el-button @click="stockDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getMaterialWarning, materialStorage } from '@/api/work'
import { getUserWorkRule } from '@/api/user'

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        search: ''
      },
      pageSize: 20,
      currentPage: 1,
      tableLoading: false,
      total: 0,
      isMenu: 0,

      stockFormLoading: false,
      btnLoading: false,
      stockTitle: 1,
      stockDialog: false,
      stockForm: {
        mid: '',
        index: '',
        num: '',
        remark: '',
        materialList: []
      },
      rules: {
        num: [{ required: true, message: '请输入数量', trigger: 'blur' }],
      },
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getMenu()
  },
  methods: {
    getMenu() {
      const data = {
        userid: this.user.dUserid,
        rule: this.user.rank,
        type: 0
      }
      getUserWorkRule(data).then(response => {
        for (const m of response.data) {
          if (m.name === '企划物料') {
            for (const menu of m.menulst) {
              if (menu.dNum === 'wlzl') {
                this.isMenu = 1
                break
              }
            }
            break
          }
        }
        this.getMaterialWarning()
      })
    },
    getMaterialWarning() {
      this.tableLoading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        groupid: this.user.dGroupid,
        isMenu: this.isMenu
      }
      getMaterialWarning(data).then(response => {
        this.total = response.total
        this.tableData = response.data
        this.tableLoading = false
      })
    },
    Search() {
      this.currentPage = 1
      this.getMaterialWarning()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getMaterialWarning()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getMaterialWarning()
    },

    operateStock(val, row) {
      this.stockTitle = val
      this.stockDialog = true
      this.stockFormLoading = false
      this.stockForm.mid = row.material_id
      this.stockForm.material_name = row.name
      this.stockForm.material_spce = row.spec
      this.stockForm.brand_name = row.brand_name
      this.stockForm.remark = ''
      this.stockForm.num = 1
    },
    handleClose(done) {
      done()
    },
    subStock(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          const data = {
            userid: this.user.dUserid,
            mid: this.stockForm.mid,
            remark: this.stockForm.remark,
            num: this.stockForm.num,
            type: this.stockTitle
          }
          materialStorage(data).then(response => {
            if (this.stockTitle === 0) {
              this.$message({
                message: '物料出库成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: '物料入库成功',
                type: 'success'
              })
            }
            this.stockForm.mid = ''
            this.stockForm.num = ''
            this.stockForm.remark = ''
            this.stockDialog = false
            this.btnLoading = false
            this.getMaterialWarning()
          }).catch(() => {
            this.btnLoading = false
          })
        } else {
          return false
        }
      })
    },

  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.tcf-row {
  .card {
    .card-body {
      .card-title {
        font-weight: 500;
        color: #404852;
        margin-bottom: 22px;
        font-size: 14px;
        .search-mode {
          width: 300px;
          position: relative;
          float: right;
          margin-top: -10px;
          .search-input {
            background-color: #F2F6FC;
            border: 0;
            height: 40px;
            line-height: 40px;
            border-radius: 4px;
            color: #606266;
            padding: 0 40px 0 15px;
            -webkit-appearance: none;
            font-size: 12px;
            width: 100%;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            outline: 0;
            &::-webkit-input-placeholder {
              color: #C0C4CC;
            }
            &::-ms-input-placeholder {
              color: #C0C4CC;
            }
          }
          .search-btn {
            position: absolute;
            right: 0;
            height: 40px;
            width: 40px;
            line-height: 40px;
            top: 0;
            border: 0;
            background: transparent;
            text-align: center;
            padding: 0;
          }
        }
      }
      .card-content {
        .client-sex {
          width: 16px !important;
          height: 16px !important;
          vertical-align: -4px !important;
        }
        .el-table::before {
          height: 0 !important;
        }
        .el-pagination {
          margin-top: 20px;
        }
      }
    }
  }
}

</style>
